import {
  canCheckIn,
  checkInOpensMs,
  hasFinalScore,
  isPredictionOpen,
  toScore,
} from './gameSchedule';

// The card and sheet rules of the embed's Games tab, kept pure so the two stay in step.

export function cardStatus(event) {
  const checkedIn = !!(event && event.already_checked_in);
  const predicted = !!(event && (event.already_predicted || event.my_prediction));
  return {
    checkIn: { label: checkedIn ? 'Check-in' : 'Not checked in', done: checkedIn },
    prediction: { label: predicted ? 'Prediction' : 'Not predicted', done: predicted },
  };
}

export function predictAction(event, nowMs, past) {
  const scored = hasFinalScore(event);
  if (scored && past) return { visible: false, label: '' };
  const predicted = !!(event && (event.already_predicted || event.my_prediction));
  const label = scored ? 'Prediction results' : predicted ? 'Your prediction' : 'Predict the score';
  return { visible: scored || predicted || isPredictionOpen(event, nowMs), label };
}

export function checkInMeta(event, nowMs) {
  if (event && event.already_checked_in) return { label: 'Check-in', icon: 'check' };
  if (canCheckIn(event, nowMs)) {
    const points = Number.isFinite(Number(event.check_in_points)) ? Number(event.check_in_points) : 500;
    return { label: `Check-in +${points} pts`, icon: null };
  }
  return { label: 'Check-in', icon: 'lock' };
}

// An upcoming card always offers Check in; the notice explains a closed window. A past card
// keeps the button only while its window is still open.
export function checkInAction(event, nowMs, past) {
  return !!event && (!past || canCheckIn(event, nowMs));
}

export function checkInNotice(event, nowMs) {
  if (event && event.already_checked_in) return null;
  if (!event || !event.check_in_enabled) return 'disabled';
  if (canCheckIn(event, nowMs)) return null;
  const opensMs = checkInOpensMs(event);
  return opensMs != null && nowMs < opensMs ? 'too_early' : 'closed';
}

export function losingSide(event) {
  if (!hasFinalScore(event)) return null;
  const home = toScore(event.home_score);
  const away = toScore(event.away_score);
  if (home === away) return null;
  return home < away ? 'home' : 'away';
}

export function squadLineText(result) {
  if (!result || !result.winner_name) return '';
  return `${result.is_you ? 'You' : result.winner_name} won the ${result.squad_name || 'squad'} prediction`;
}

// The game-winners payload folded onto the events: each squad that has a winner for a game
// adds a line to that game.
export function attachSquadResults(events, payload) {
  const squads = Array.isArray(payload?.squads) ? payload.squads : [];
  if (!squads.length) return events;
  return events.map((event) => {
    const results = [];
    squads.forEach((squad) => {
      const winner = squad?.winners?.[String(event.id)];
      if (!winner) return;
      results.push({
        squad_id: squad.id,
        squad_name: squad.name,
        cover_url: squad.cover_url || '',
        winner_name: winner.display_name || '',
        is_you: !!winner.is_you,
      });
    });
    return results.length ? { ...event, squad_results: results } : event;
  });
}
